import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import {
  castVoteForArtist,
  fetchArenaArtists,
  getActiveContests,
  getAllLeaderboards,
  participateArenaUrl,
} from "../../services";

const initialState = {
  andArenaArtistsByCategory: [],
  loadingAndArenaArtistsByCategory: false,
  error: null,
  totalAndArenaArtistsByCategory: 0,
  leaderboards: [],
  loadingLeaderboards: false,
  errorLeaderboards: null,
  activeContests: [],
  loadingActiveContests: false,
  errorActiveContests: null,
  castVoteLoading: false,
  castVoteError: null,
  participateArenaLoading: false,
  participateArenaError: null,
};

export const fetchParticipantsByCategory = createAsyncThunk(
  "andArena/fetchParticipantsByCategory",
  async (request) => {
    const response = await HttpApiClient.post(fetchArenaArtists, request);

    return response?.data?.data;
  }
);

export const fetchActiveContests = createAsyncThunk(
  "andArena/fetchActiveContests",
  async (request) => {
    const response = await HttpApiClient.post(getActiveContests, request);
    return response?.data;
  }
);

export const fetchAllLeaderboards = createAsyncThunk(
  "andArena/getAllLeaderboards",
  async (request) => {
    const response = await HttpApiClient.post(getAllLeaderboards, request);
    return response.data.payload;
  }
);

export const castVote = createAsyncThunk(
  "andArena/castVote",
  async (request) => {
    const response = await HttpApiClient.post(castVoteForArtist, request);
    return response.data.payload;
  }
);

export const participateInArena = createAsyncThunk(
  "andArena/participateInArena",
  async (request) => {
    const response = await HttpApiClient.post(participateArenaUrl, request);
    return response.data.payload;
  }
);

const andArenaSlice = createSlice({
  name: "andArena",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParticipantsByCategory.pending, (state) => {
        state.loadingAndArenaArtistsByCategory = true;
        state.error = null;
      })
      .addCase(fetchParticipantsByCategory.fulfilled, (state, action) => {
        state.loadingAndArenaArtistsByCategory = false;
        state.andArenaArtistsByCategory = action.payload.participants;
        state.totalAndArenaArtistsByCategory = action.payload.totalParticipants;
      })
      .addCase(fetchParticipantsByCategory.rejected, (state, action) => {
        state.loadingAndArenaArtistsByCategory = false;
        state.error = action.error.message;
      })
      .addCase(fetchActiveContests.pending, (state) => {
        state.loadingActiveContests = true;
        state.errorActiveContests = null;
      })
      .addCase(fetchActiveContests.fulfilled, (state, action) => {
        state.loadingActiveContests = false;
        state.activeContests = action.payload.data.results;
      })
      .addCase(fetchActiveContests.rejected, (state, action) => {
        state.loadingActiveContests = false;
        state.errorActiveContests = action.error.message;
      })
      .addCase(fetchAllLeaderboards.pending, (state) => {
        state.loadingLeaderboards = true;
        state.errorLeaderboards = null;
      })
      .addCase(fetchAllLeaderboards.fulfilled, (state, action) => {
        state.loadingLeaderboards = false;
        state.leaderboards = action.payload;
      })
      .addCase(fetchAllLeaderboards.rejected, (state, action) => {
        state.loadingLeaderboards = false;
        state.errorLeaderboards = action.error.message;
      })
      .addCase(castVote.pending, (state) => {
        state.castVoteLoading = true;
        state.castVoteError = null;
      })
      .addCase(castVote.fulfilled, (state) => {
        state.castVoteLoading = false;
      })
      .addCase(castVote.rejected, (state, action) => {
        state.castVoteLoading = false;
        state.castVoteError = action.error.message;
      })
      .addCase(participateInArena.pending, (state) => {
        state.participateArenaLoading = true;
        state.participateArenaError = null;
      })
      .addCase(participateInArena.fulfilled, (state) => {
        state.participateArenaLoading = false;
      })
      .addCase(participateInArena.rejected, (state, action) => {
        state.participateArenaLoading = false;
        state.participateArenaError = action.error.message;
      });
  },
});

export default andArenaSlice.reducer;
